import Api, { baseURL } from "./Api"

const BASE = `${baseURL("v2")}/ceps`

export default {
  buscaCep(cep) {
    return Api.one(`${BASE}/busca-cep/${cep}`)
  },
}
